/** Components **/
import DefaultRangeFilterToolTip from './../../../components/Dashboards/Barometer/FilterToolTips/DefaultRangeFilterToolTip';
import TableHeaderTitleWithPicto from './../../../components/Dashboards/Barometer/TableHeaders/TitleWithPicto';
import DefaultSumTotalCell from './../../../components/Dashboards/Barometer/TableTotalCells/DefaultSumTotalCell';
import TableCellVolume from './../../../components/Dashboards/Barometer/TableCells/Volume';

export const VolumeColumn = ( barometerContext, widthColumns ) => 
{
  return {
    accessor: "volume",
    width: widthColumns['volume'],
    title: "volume",
    className: "col-volume",
    Filter: DefaultRangeFilterToolTip,
    filter: 'multiFieldsCustomFilter',
    filterTitle: 'volumes de recherche',    
    sortDescFirst: true,
    sortType: 'valueSort',
    Header: props =>
      <TableHeaderTitleWithPicto 
        {...props.getToggleAllPageRowsSelectedProps()} 
        id={props.column.id} 
        title={props.column.title} 
      />,
    Total: props => 
      <DefaultSumTotalCell 
        id={props.column.id} 
      />,
    Cell: props =>
      <TableCellVolume 
        id={props.row.id} 
        keywords={
          barometerContext === 'urls' ?
            props.row.original['keywords-assigned']
            : props.row.original.keywords
        } 
        context={barometerContext}
        values={props.value} 
      />
  }
}